module.exports = __webpack_public_path__ + "media/hit.c0ba6411.mp3";